import React from "react";

import LoanCalculator from "./LoanCalculator/LoanCalculator";
import LoanCalculatorSlim from "./LoanCalculator/LoanCalculatorSlim";

export interface ICalculatorSection {
  alias: string;
  anchorId: string;
  calculatorType: string;
  calculator: any;
}

const CalculatorSection: React.FC<ICalculatorSection> = (props) => {
  //TODO Resolve by calculatorType when we get more calculators, for now we just separate the regular and (new) slim layout
  return props.calculator.type.toLowerCase() === "slim" ? (
    <LoanCalculatorSlim {...props.calculator} />
  ) : (
    <LoanCalculator {...props.calculator} />
  );
};

export default CalculatorSection;
